import { format, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui/base/tooltip';
import { cn } from '@/nucleo/utilitarios';

interface RelativeTimeProps {
  date: string | Date | null;
  /** Formato do tooltip com a data absoluta. Padrão: "dd/MM/yyyy HH:mm". */
  tooltipFormat?: string;
  /** Texto mostrado quando a data é nula/inválida. Padrão: "—". */
  emptyLabel?: string;
  className?: string;
}

/**
 * Data relativa ("há 3 dias") inline, com a data absoluta em tooltip —
 * cópia do protótipo (`RelativeTime.tsx`).
 */
export function RelativeTime({
  date,
  tooltipFormat = 'dd/MM/yyyy HH:mm',
  emptyLabel = '—',
  className,
}: RelativeTimeProps) {
  const instante = date ? (typeof date === 'string' ? new Date(date) : date) : null;

  if (!instante || Number.isNaN(instante.getTime())) {
    return <span className={cn('text-muted-foreground text-xs', className)}>{emptyLabel}</span>;
  }

  const relativo = formatDistanceToNow(instante, { locale: ptBR, addSuffix: true });
  const absoluto = format(instante, tooltipFormat, { locale: ptBR });

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn('text-muted-foreground text-xs', className)}>{relativo}</span>
        </TooltipTrigger>
        <TooltipContent>{absoluto}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default RelativeTime;
